import { render, staticRenderFns } from "./AddExamObjectByScope.vue?vue&type=template&id=53a781e4&scoped=true&"
import script from "./AddExamObjectByScope.vue?vue&type=script&lang=js&"
export * from "./AddExamObjectByScope.vue?vue&type=script&lang=js&"
import style0 from "./AddExamObjectByScope.vue?vue&type=style&index=0&id=53a781e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a781e4",
  null
  
)

export default component.exports